import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyAlnN9dS1OXmc25BAdguCcu-6Xpn_su9k0',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'docex-58657.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'docex-58657',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'docex-58657.appspot.com',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '509515699254',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:509515699254:web:5876dbbb5052b5d4ca3497',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-H1MJWEL47F',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);

export { auth };
export default app;
